import { CardCvcElement, CardExpiryElement, CardNumberElement, useElements, useStripe } from '@stripe/react-stripe-js';

export default function PaymentForm(props) {
    const stripe = useStripe();
    const elements = useElements();
    const { readyToSubmit, setAlert, paymentInfo, setPaymentInfo, submitFormAndBook } = props;

    const handleSubmit = async () => {
        if (!stripe || !elements) {
            // Stripe.js has not yet loaded.
            return;
        }
        const card = elements.getElement(CardNumberElement);
        const {
            token, error
        } = await stripe.createToken(card)

        if (error) {
            setAlert('error', error.message);
            return;
        } else {
            submitFormAndBook(token)
        }
    };

    return (<>
        <div className="row">
            <div className={`col-12`}>
                <div className={`form-group mb-16`}>
                    <label className="mb-8 font-weight-bold size-16-20">Card Number*</label>
                    <CardNumberElement className="form-control generic-input-style"
                        onChange={(e) => {
                            if (e.complete) {
                                setPaymentInfo({
                                    ...paymentInfo,
                                    card_number: "value"
                                })
                            } else {
                                setPaymentInfo({
                                    ...paymentInfo,
                                    card_number: ""
                                })
                            }
                        }} />
                </div>
            </div>
            <div className={`col-12 col-sm-6 `}>
                <div className={`form-group mb-16`}>
                    <label className="mb-8 font-weight-bold size-16-20">Expiration (MM/YY)*</label>
                    <CardExpiryElement className="form-control generic-input-style"
                        onChange={(e) => {
                            if (e.complete) {
                                setPaymentInfo({
                                    ...paymentInfo,
                                    card_expiry: "value"
                                })
                            } else {
                                setPaymentInfo({
                                    ...paymentInfo,
                                    card_expiry: ""
                                })
                            }
                        }} />
                </div>
            </div>
            <div className={`col-12 col-sm-6 `}>
                <div className={`form-group mb-16`}>
                    <label className="mb-8 font-weight-bold size-16-20">CVC*</label>
                    <CardCvcElement className="form-control generic-input-style"
                        onChange={(e) => {
                            if (e.complete) {
                                setPaymentInfo({
                                    ...paymentInfo,
                                    card_cvc: "value"
                                })
                            } else {
                                setPaymentInfo({
                                    ...paymentInfo,
                                    card_cvc: ""
                                })
                            }
                        }} />
                </div>
            </div>
            <div className={`col-12 `}>
                <div className={`form-group mb-16`}>
                    <label htmlFor="zipCode" className="mb-8 font-weight-bold size-16-20">Zip Code*</label>
                    <input type="text" id="zipCode" className="form-control generic-input-style" placeholder='Enter'
                        autoComplete='off'
                        value={paymentInfo.card_zip} onChange={(event) => setPaymentInfo({ ...paymentInfo, card_zip: event.target.value })}
                        required
                    />
                </div>
            </div>
        </div>
        <div className='fxd-btm'>
            <span className='mr-16 size-18-24 font-weight-bold'>By clicking "Book" above, you agree to our <a className='BluePrimary' href="https://www.soothe.com/terms-and-conditions/">Terms and Conditions</a> and <a className='BluePrimary'
                href="https://www.soothe.com/privacy-policy/">Privacy Policy</a></span>
            <button
                type="button"
                className="btn cta-primary p-16-20-imp"
                disabled={!readyToSubmit}
                onClick={(e) => {
                    e?.preventDefault();
                    if (!readyToSubmit) return;
                    handleSubmit();
                }}
            >
                Book now
            </button>
        </div>
    </>
    );

}